const Reminder =  (props:any)=>{
    const fontWeight = {
        'fontWeight': 'bold'
    }
    return <div className="j_tanc">
    <div className="j_content">
        <p>IOS需要手动信任企业证书才能正常使用</p>
        <p style={fontWeight}>请在设置&gt;通用&gt;设备管理，</p>
        <p style={fontWeight}>选择并信任企业级应用"Taikang Life Insurance Co.,Ltd"</p>
        <h3 onClick={(event)=>{event.preventDefault();props.controlShowEvent()}}><span className="hover">我知道了</span></h3>
    </div>
</div>
}

export default Reminder